document.addEventListener('DOMContentLoaded', function () {
  const treatments = document.querySelectorAll('.treatment-card__container');

  treatments.forEach(treatment => {
    const checkbox = treatment.querySelector('input[type="checkbox"][name="agreement"]');
    const placeholderButton = treatment.querySelector('button[id^="placeholderButton-"]');
    const grvButton = treatment.querySelector('div[id^="grvButton-"]');

    if (!checkbox || !placeholderButton) return;

    checkbox.addEventListener('change', () => {
      placeholderButton.disabled = !checkbox.checked;
      if (grvButton) grvButton.style.display = checkbox.checked ? 'block' : 'none';
      placeholderButton.style.display = checkbox.checked ? 'none' : 'block';
    });
  });
});
